const set_up_termRouter = [
    {
        path: "list-set_up_term",
        name: "list",
        component: () => import("@/views/admin/set_up_term"),
        default: true,
        meta: {
            model: "set_up_term",
            // requiresAuth: true,
        },
    },
    {
        path: "list-set_up_term/add",
        name: "add",
        component: () => import("@/views/admin/set_up_term/function"),
        default: true,
        meta: {
            model: "set_up_term",
            // requiresAuth: true,
        },
    },
    {
        path: "list-set_up_term/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/set_up_term/function"),
        default: true,
        meta: {
            model: "set_up_term",
            // requiresAuth: true,
        },
    },
  ];
  export default set_up_termRouter;